import { Breadcrumb } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { type IndexedBreadcrumbProps } from "../MemberBreadcrumbs.types";
import { getBreadURL } from "../utils/Breadcrumb.functions";

import BreadcrumbName from "./BreadcrumbName.component";

const LinkBreadcrumb = ({
  currentName,
  currentIndex,
}: IndexedBreadcrumbProps) => {
  const navigate = useNavigate();
  const currentUrl = getBreadURL(currentIndex);

  return (
    <Breadcrumb.Item
      onClick={() => {
        return navigate(currentUrl);
      }}
    >
      <BreadcrumbName currentName={currentName} />
    </Breadcrumb.Item>
  );
};

export default LinkBreadcrumb;
